import { Box, Flex, Image, LinkBox } from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import { Link as ReactRouterLink, Route, Routes } from 'react-router-dom';
import PageDataContext from '../context/PageDataContext';
import { usePageDataCache } from '../hooks/usePageDataCache';
import { getGameInfo } from '../service/games';
import { getLeaderboards } from '../service/leaderboard';

interface LeaderboardGamePageProps {
    children?: React.ReactNode;
}

const LeaderboardGamePage: React.FC<LeaderboardGamePageProps> = ({ children }) => {
    return (
        <Box>
            <Routes>
                <Route path="rank/:leaderboardName/*" element={<LeaderboardRankPage />} />
                <Route path="*" element={<LeaderboardMainPage />} />
            </Routes>
        </Box>
    );
};

interface LeaderboardRankPageProps {
    children?: React.ReactNode;
}

const LeaderboardRankPage: React.FC<LeaderboardRankPageProps> = ({ children }) => {
    return <></>;
};

interface LeaderboardMainPageProps {
    children?: React.ReactNode;
}

const LeaderboardMainPage: React.FC<LeaderboardMainPageProps> = ({ children }) => {
    const { isLoadFromCache } = useContext(PageDataContext);
    const [games, setGames] = usePageDataCache<any[]>('games', []);

    useEffect(() => {
        async function getGames() {
            const games = await getGameInfo();
            setGames(games);
        }
        if (!isLoadFromCache) {
            getGames();
        }
    }, []);

    return (
        <Flex flexDirection={'column'}>
            {games.map((game) => (
                <LinkBox as={ReactRouterLink} to={`/leaderboards/${game.id}`}>
                    {game.name}
                    <Image src={game.header}></Image>
                </LinkBox>
            ))}
        </Flex>
    );
};

interface LeaderboardPageProps {
    children?: React.ReactNode;
}

export const LeaderboardPage: React.FC<LeaderboardPageProps> = ({ children }) => {
    const { isLoadFromCache } = useContext(PageDataContext);

    const [leaderboards, setLeaderboards] = usePageDataCache<any[]>('leaderboards', []);
    const [selectedLicense, setSelectedLicense] = usePageDataCache(
        'selectedLicense',
        'd2eea033-f28d-41c6-a992-f85a55c70ab2',
    );

    useEffect(() => {
        async function test() {
            const result = await getLeaderboards(selectedLicense);
            console.log('result', result);
            setLeaderboards(result);
        }

        if (!isLoadFromCache) {
            test();
        }
        // const guestToken = await getGuestToken(); TODO use guest token for things if not logged in
    }, []);

    return (
        <Box>
            <Routes>
                <Route path="game/:gameId/*" element={<LeaderboardGamePage />} />
                <Route path="*" element={<LeaderboardMainPage />} />
            </Routes>
        </Box>
    );
};
